/**
 * Countdown days, hours, minutes and seconds
 * @module countdown
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const SECOND = 1000;
export const MINUTE = SECOND * 60;
export const HOUR = MINUTE * 60;
export const DAY = HOUR * 24;

export const DAY_CONTAINER = '.js-countdown-day';
export const HOURS_AS_DAYS_CONTAINER = '.js-countdown-hours-as-days';
export const HOUR_CONTAINER = '.js-countdown-hour';
export const MINUTE_CONTAINER = '.js-countdown-minute';
export const SECOND_CONTAINER = '.js-countdown-second';
export const DAY_LABEL = '.js-countdown-day-label';
export const HOURS_AS_DAYS_LABEL = '.js-countdown-hours-as-days-label';
export const HOUR_LABEL = '.js-countdown-hour-label';
export const MINUTE_LABEL = '.js-countdown-minute-label';
export const SECOND_LABEL = '.js-countdown-second-label';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'countdown';
export const DEFAULTS = {
    targetDateTime: '2029-12-01T00:00:00-08:00',
    timerEndText: null,
};
/**
 * Updates the countdown display elements
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {number} timeLeft - amount of time still left in the countdown
 */
const updateCountdownDisplay = ($el, options = {}, timeLeft) => {
    const daysLeft = Math.floor(timeLeft / (DAY));
    const daysLeftCheck = daysLeft === 0 ? daysLeft : (daysLeft * 24);
    let hoursDaysLeft = Math.floor(((timeLeft % DAY) / (HOUR)) + (daysLeftCheck));
    hoursDaysLeft = hoursDaysLeft < 10 ? (`00${hoursDaysLeft}`).slice(-2) : hoursDaysLeft;
    const hoursLeft = (`00${Math.floor((timeLeft % (DAY)) / (HOUR))}`).slice(-2);
    const minutesLeft = (`00${Math.floor((timeLeft % (HOUR)) / (MINUTE))}`).slice(-2);
    const secondsLeft = (`00${Math.floor((timeLeft % (MINUTE)) / (SECOND))}`).slice(-2);

    $el.find(DAY_CONTAINER).text(daysLeft);
    $el.find(HOUR_CONTAINER).text(hoursLeft);
    $el.find(HOURS_AS_DAYS_CONTAINER).text(hoursDaysLeft);
    $el.find(MINUTE_CONTAINER).text(minutesLeft);
    $el.find(SECOND_CONTAINER).text(secondsLeft);

    $el.find(DAY_LABEL).text((daysLeft === 1 ? 'day' : 'days'));
    $el.find(HOUR_LABEL).text((hoursLeft % 24 === 1 ? 'hour' : 'hours'));
    $el.find(HOURS_AS_DAYS_LABEL).text((hoursDaysLeft === 1 ? 'hour' : 'hours'));
    $el.find(MINUTE_LABEL).text((minutesLeft % 60 === 1 ? 'minute' : 'minutes'));
    $el.find(SECOND_LABEL).text((secondsLeft % 60 === 1 ? 'second' : 'seconds'));
};
/**
 * Runs the countdown and sets the interval
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const runCountdown = ($el, options = {}) => {
    const target = new Date(options.targetDateTime).getTime();

    const intervalId = setInterval(() => {
        const now = new Date().getTime();
        const timeLeft = target - now;

        // Stop countdown at zero
        if (timeLeft <= 0) {
            clearInterval(intervalId);
            updateCountdownDisplay($el, options, 0);

            // Display end text if provided
            if (options.timerEndText) {
                $el.html(options.timerEndText);
            }

            return;
        }

        updateCountdownDisplay($el, options, timeLeft);
    }, SECOND);
};
/**
 * Initializes countdown
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function countdown(el, options = {}) {
    const $el = $(el);
    const opts = mergeOptions(DEFAULTS, options, $el);
    runCountdown($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, countdown);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/countdown.js